package er.prateek.crossly.ui.theme

import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Shapes
import androidx.compose.ui.unit.dp

/** One spacing scale for the whole app — screens never hand-pick arbitrary dp. */
object Spacing {
    val xxs = 2.dp
    val xs = 4.dp
    val sm = 8.dp
    val md = 12.dp
    val lg = 16.dp
    val xl = 24.dp
    val xxl = 32.dp
    val xxxl = 48.dp
}

/** Generously rounded throughout — the single strongest "this is a game" cue. */
val AppShapes = Shapes(
    extraSmall = RoundedCornerShape(8.dp),
    small = RoundedCornerShape(12.dp),
    medium = RoundedCornerShape(18.dp),
    large = RoundedCornerShape(24.dp),
    extraLarge = RoundedCornerShape(32.dp),
)

object Radius {
    val cell = 8.dp
    val chip = 999.dp
    val button = 18.dp
    val card = 24.dp
    val panel = 28.dp
}

/**
 * Depth offset for "sticker" surfaces: a solid shadow layer sits this far below
 * the face, and the face travels down by the same amount when pressed.
 */
object Depth {
    val button = 5.dp
    val buttonSmall = 3.dp
    val card = 4.dp
}
